// extracted by mini-css-extract-plugin
module.exports = {"card":"UserCard-card-1529","inner":"UserCard-inner-1529"};